/* app/controls/control.news-filters */

import $ from 'jquery';

var module = {
	init: function () {
		this._bindFilterToggles();

	},
	_bindFilterToggles: function () {
		const toggles = document.querySelectorAll('[data-filter-toggler]');

		function closeAllToggles() {
			toggles.forEach(toggle => toggle.classList.remove('is-showing'));
		}

		function handleToggleClick(event) {


			//event.stopPropagation();
			const clickedToggle = event.currentTarget;
			const isAlreadyOpen = clickedToggle.classList.contains('is-showing');


			// Close all toggles first
			closeAllToggles();

			// Reopen only the clicked one (if it wasn’t already open)
			if (!isAlreadyOpen) {
				clickedToggle.classList.add('is-showing');
				console.log({ clickedToggle });

			}
		}

		function handleClickOutside(event) {
			const clickedInsideToggler = event.target.closest('[data-filter-toggler]');
			const clickedInsidePanel = event.target.closest('[data-filter-panel]');

			// If click is outside both toggler and panel, close all toggles
			if (!clickedInsideToggler && !clickedInsidePanel) {
				closeAllToggles();
			}
		}


		// Bind toggle click events
		toggles.forEach(toggle => {

			toggle.addEventListener('click', handleToggleClick);
		});

		// Listen for clicks anywhere else
		document.addEventListener('click', handleClickOutside);
	},
};

export { module as NewsFilters };
